import { NG_VALIDATORS, AbstractControl } from '@angular/forms'
import { Directive, Input } from '@angular/core';
import _ from 'lodash';

@Directive({
  selector: '[emailValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective , multi: true }]
})
export class EmailValidatorDirective {

  constructor() { }
  ngOnInit() {
  }

  
  @Input('emailValidator') 
   set emailValidator(val) {
    
    }

  validate(c: AbstractControl) {    
    if(!!!c.value)
    {
      return null;
    }
    let emlStr = c.value;      
    var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var result = emlStr.replace(/\s/g, "").split(/,|;/);
    for (var i = 0; i < result.length; i++) {
      if (!regex.test(result[i])) {
         return { emailValidator: true, errorMessage: "Please enter a valid email address" };        
      }
    }
      return null;
    }
    
}